// extracted by mini-css-extract-plugin
module.exports = {"tutorial":"Rn1FoAlE","side":"HzUKBTrO","menu-item":"gJveYe3D","wrap":"X1iTo4vP","txt":"dIFdcHF_","active":"up6HlO4k","main":"u_eLsQRQ","section":"zR0u3gSn","footer":"__6BYOVcBh"};